import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Loading from './Loading';

export default function ProtectedRoute({ children, roles, redirectPath = '/' }) {
  const location = useLocation();
  const { loading, isLoggedIn, hasRole } = useAuth();

  if (!isLoggedIn && loading) return <Loading />;

  if (!isLoggedIn) {
    return <Navigate replace to='/login' state={{ from: location.pathname }} />;
  }

  if (isLoggedIn && roles && !hasRole(...roles)) {
    return <Navigate replace to={redirectPath} />;
  }

  return children || <Outlet />;
}
